var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.getStyle)},[_c('Login',{on:{"type":_vm.setStyle,"login":function($event){return _vm.back()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }